export enum TransactionStatus {
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected',
}
